/* eslint-disable indent */
// import { yupResolver } from '@hookform/resolvers/yup';
import { getDetail, getGeneralProjectProposalInfo } from 'apis/prequalificationReviews.api';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useEffect, useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import ReactRouterPrompt from 'react-router-prompt';
import { TabPanel, TabView } from 'primereact/tabview';
import { ProjectProposalDefenseDetail } from 'features/ProjectProposalDefense/pages';
import {
  DynamicPrequalificationForm,
  PrequalificationForm,
} from 'features/PrequalificationReview/components';
import { is1593 } from 'utils/func';
import GeneralCouncilInfo from 'features/Council/components/GeneralInfo';

export default function PrequalificationReviewFormDetail() {
  const { t } = useTranslation();
  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);
  const [tab, setTab] = useState(0);
  const { projectProposalId } = useParams();
  const [searchParams] = useSearchParams();
  const councilId = searchParams.get('councilId');
  const councilMemberId = searchParams.get('councilMemberId');

  const location = useLocation();
  const { isViewCouncilData } = location?.state || { isViewCouncilData: false };

  const { data: dataGeneralProjectProposalInfo, isLoading: isLoadingProjectProposal } = useQuery(
    ['prequalification-review', 'project-proposal', councilId, projectProposalId],
    ({ queryKey: [, , _councilId, _projectProposalId] }) =>
      getGeneralProjectProposalInfo(_councilId, _projectProposalId)
  );

  const {
    data: _data,
    isLoading: isLoadingPrequalificationReview,
    // refetch: refetchPrequalificationReview,
  } = useQuery(
    ['prequalification-review', 'detail', councilMemberId, councilId, projectProposalId],
    ({ queryKey: [, , _councilMemberId, _councilId, _projectProposalId] }) =>
      getDetail(_councilMemberId, _councilId, _projectProposalId),
    {
      enabled: !is1593(dataGeneralProjectProposalInfo?.data?.template) && !isLoadingProjectProposal,
    }
  );

  const prequalificationReviewData = useMemo(() => _data?.data ?? {}, [_data]);
  const prequalificationReview = useMemo(
    () => prequalificationReviewData?.prequalificationReview || {},
    [prequalificationReviewData]
  );
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: {
      errors,
      // , isValid
    },
  } = useForm({
    mode: 'onChange',
    // resolver: yupResolver(createMidtermReviewValidationSchema),
  });
  const { ...formOptions } = useForm({
    mode: 'onChange',
  });
  const { isDirty, dirtyFields } = useFormState({ control });
  useEffect(() => {
    if (prequalificationReview) {
      reset(prequalificationReview);
      setValue(
        'isNotQualified',
        prequalificationReview?.generalEvaluate != null && !prequalificationReview?.generalEvaluate
      );
      setValue('otherOpinionTickbox', !!prequalificationReview?.otherOpinion);
    }
  }, [prequalificationReviewData]);

  const footerConfirmationPrompt = (onConfirm, onCancel) => (
    <div>
      <Button
        label={t('formLayout.action.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={onCancel}
        autoFocus
      />
      <Button
        label={t('formLayout.action.ok')}
        className="w-7rem"
        severity="info"
        onClick={onConfirm}
      />
    </div>
  );
  // #endregion

  return (
    <>
      <ReactRouterPrompt when={isDirty && Object.keys(dirtyFields).length}>
        {({ isActive, onConfirm, onCancel }) => (
          <Dialog
            visible={isActive}
            header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
            position="center"
            style={{ width: '300px' }}
            onHide={onCancel}
            draggable={false}
            footer={() => footerConfirmationPrompt(onConfirm, onCancel)}
          >
            <p className="text-lg py-3">{t('projectProposal.confirmationPromptMessage')}</p>
          </Dialog>
        )}
      </ReactRouterPrompt>
      <TabView activeIndex={tab} onTabChange={(e) => setTab(e.index)}>
        <TabPanel header={t('council.review.createOrUpdate')} leftIcon="pi pi-file mr-2">
          {is1593(dataGeneralProjectProposalInfo?.data?.template) || isLoadingProjectProposal ? (
            <DynamicPrequalificationForm
              projectProposalId={projectProposalId}
              councilId={councilId}
              councilMemberId={councilMemberId}
              generalInfo={dataGeneralProjectProposalInfo?.data}
              isLoading={isLoadingProjectProposal}
              readOnly
              formOptions={formOptions}
            />
          ) : (
            <PrequalificationForm
              isDetailFrom
              isLoading={isLoadingPrequalificationReview}
              disabled
              handleSubmit={handleSubmit}
              onSubmit={() => true}
              isErrorRes={false}
              control={control}
              watch={watch}
              setValue={setValue}
              getValues={getValues}
              isDirty={isDirty}
              dirtyFields={dirtyFields}
              errors={errors}
              isValid
              isVisibleErrorDialog={isVisibleErrorDialog}
              setIsVisibleDialogError={setIsVisibleDialogError}
              dataGeneralProjectProposalInfo={dataGeneralProjectProposalInfo}
            />
          )}
        </TabPanel>
        <TabPanel header={t('council.review.detailProjectProposal')} leftIcon="pi pi-list mr-2">
          <ProjectProposalDefenseDetail />
        </TabPanel>
        {isViewCouncilData && (
          <TabPanel header={t('council.review.councilInfo')} leftIcon="pi pi-info-circle mr-2">
            <GeneralCouncilInfo councilId={councilId} projectProposalId={projectProposalId} />
          </TabPanel>
        )}
      </TabView>
    </>
  );
}
